export interface ScopeOwnedAsyncRequest {
  readonly scopeKey: string;
  readonly revision: number;
}

export class ScopeOwnedAsyncRequestTracker {
  private revision = 0;

  begin(scopeKey: string): ScopeOwnedAsyncRequest {
    const normalizedScopeKey = normalizeScopeKey(scopeKey);
    if (!normalizedScopeKey) {
      throw new Error('A non-empty async request scope is required.');
    }

    return {
      scopeKey: normalizedScopeKey,
      revision: ++this.revision,
    };
  }

  invalidate(): void {
    this.revision += 1;
  }

  owns(
    request: ScopeOwnedAsyncRequest,
    activeScopeKey: string | null | undefined
  ): boolean {
    return request.revision === this.revision
      && request.scopeKey === normalizeScopeKey(activeScopeKey);
  }
}

function normalizeScopeKey(value: string | null | undefined): string {
  return value?.trim().toLowerCase() ?? '';
}
